import { RadioButtonGroup } from "../atoms/RadioButton";

export const TypeSelector = ({ value, onChange }) => (
  <RadioButtonGroup
    name="positionType"
    value={value}
    onChange={onChange}
    className="font-MTNfont"
    data={[
      { value: "New", label: "New Position" },
      { value: "Replacement", label: "Replacement" },
    ]}
  />
);
